import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routerList = [
	{
	    path: '/404',
	    component: () => import( '../../pages/404.vue'),
	    name:'nodata404',
	    meta: {title: '抱歉您找的页面失踪了'},
	},
	{
	    path: '/auth',
	    component: () => import( '../../pages/Auth.vue'),
	    name:'auth',
	    meta: {title: '登录校验中'},
	},
	{
		path: "/merchant/login",
		component: () => import('../../pages/platform/login.vue'),
		meta: {title: '商户登录'},
		name: 'pt_login',
		children:[],
	},
	{
		path: "/merchant/index",
		component: () => import('../../pages/platform/index.vue'),
		meta: {title: '商户管理中心'},
		name: 'pt_index',
		children:[],
	},
	{
	    path: '/expire',
	    component: () => import( '../../pages/platform/expire.vue'),
	    name:'expire',
	    meta: {title: '登录已超时'},
	},
	{
		path: "/ptlogin",
		component: () => import('../../pages/platform/staffLogin.vue'),
		meta: {title: '平台登录中心'},
		name: 'staff_login',
		children:[],
	},
];

const storeRouter = {
	    path: "/layout",
	    component: () => import('../../pages/Layout.vue'),
	    meta: {title: '总后台'},
	    name: 'layout',
		children:[
			{
			    path: '/refresh',
			    component: () => import( '../../pages/Refresh.vue'),
			    name:'refresh',
			    meta: {title: '刷新页面'},
			}
		]
}

const files = require.context('./routers', false, /\.js$/)

files.keys().forEach(key => {
    let menuLocal = files(key).default;
    for(var  a in menuLocal){
        storeRouter.children.push(menuLocal[a]);
    }
})
routerList.push(storeRouter);


const routerObj = new VueRouter({
    routes:routerList
});


routerObj.beforeEach((to, from, next) => { 
     if(to.name == null){
        next({
            path:'/404'
        });
     }else{
       document.title =  to.meta.title + ' - 预约小程序管理后台'

	   console.log('to.meta.permission-type',to.meta.permission,to.meta.type)
	   	// 检查是否需要权限验证，防止直接访问
		if (to.meta.permission) {
			if(to.meta.type == 'm'){
				const userPermissionsByM = getUserPermissionsByM()
				
				if (userPermissionsByM != 'all' && !userPermissionsByM.includes(to.meta.permission)) {
					// 没有权限，跳转到无权限页面或首页
					next({ path: '/404' })
					return
				}
			}
			if(to.meta.type == 'c'){
				const userPermissionsByC = getUserPermissionsByC()
				// console.log('kskd',userPermissionsByC)
				if (userPermissionsByC != 'all' && !userPermissionsByC.includes(to.meta.permission)) {
					// 没有权限，跳转到无权限页面或首页
					next({ path: '/404' })
					return
				}
			}
			if(to.meta.type == 'a'){
				const userPermissionsByA = getUserPermissionsByA()
				
				if (userPermissionsByA != 'all' && !userPermissionsByA.includes(to.meta.permission)) {
					// 没有权限，跳转到无权限页面或首页
					next({ path: '/404' })
					return
				}
			}
		}

       	next();
     }
})

// 目录权限
function getUserPermissionsByM() {
	const mulu = localStorage.getItem('beautiful-mulu') || ''
	if(mulu == 'all'){
		return 'all'
	}
	return mulu.split(',')
}

// 菜单权限
function getUserPermissionsByC() {
	const caidan = localStorage.getItem('beautiful-caidan') || ''
	if(caidan == 'all'){
		return 'all'
	}
	return caidan.split(',')
}

// 按钮权限
function getUserPermissionsByA() {
	const anniu = localStorage.getItem('beautiful-anniu') || ''
	if(anniu == 'all'){
		return 'all'
	}
	return anniu.split(',')
}

export default routerObj;